import { PerformanceAnalysisViewState } from '@models/SavedViews';
import CreateCopyViewButton from '../copy-view/CreateCopyViewButton';
import React from 'react';
import { SavedViewButtonsTrackingTags } from '@ecosystem/newron-client-lib/build/saved-views/types';

export interface Props {
  performanceAnalysisViewState: PerformanceAnalysisViewState;
  copyViewTracking: Object;
}

const PerformanceAnalysisCopyViewButton: React.FC<Props> = ({ performanceAnalysisViewState, copyViewTracking }) => {
  const createViewState = () => {
    return performanceAnalysisViewState;
  };
  const createTrackingTags = () => {
    return copyViewTracking as SavedViewButtonsTrackingTags;
  };

  return <CreateCopyViewButton createViewFunction={createViewState} copyViewTracking={createTrackingTags} />;
};

export default PerformanceAnalysisCopyViewButton;
